import React from 'react';

export function useTransitionEndEventName() {
    const transitionEndEventName = () => {
        var el = document.createElement('div')
        var transEndEventNames = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend'
        }
        for (var name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return transEndEventNames[name];
            }
        }
        return false
    }
    return transitionEndEventName()
}